import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { GET_KYC_LISTING_FORM } from "../../../Types";

const handleApiError = (error) => {
  if (error.response) {
    if (error.response.status === 401) {
      logout();
      history.push("/login");
      history.go("/login");
      return;
    }
    if (error.response.status === 400 && error.response.data.errors) {
      let errorMessage = "";
      var errors = error.response.data.errors;
      var keys = Object.keys(errors);
      for (let j = 0; j < keys.length; j++) {
        errorMessage += errors[keys[j]] + " , \n";
      }
      toast.error(errorMessage);
      return;
    }
    if (error.response.data)
      toast.error(
        error.response.data.Message
          ? error.response.data.Message
          : error.response.data.message
      );
    else toast.error("Error while processing the request");
  } else {
    toast.error("Error while processing the request");
  }
};

export const getKYCListingForm = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/LenderKYC/GetKYCListingForm`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_KYC_LISTING_FORM,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      handleApiError(error);
    });
};

export const toggleKYCActive = (Id, onSuccess = () => {}) => async (
  dispatch
) => {
  dispatch(showLoading());
  await axios
    .get(`api/LenderKYC/ActiveDeactiveKyc/${Id}`)
    .then(({ data }) => {
      dispatch(hideLoading());
      if (data.response == null) {
        toast.error("record not found");
        return;
      }
      onSuccess(data.response);
    })
    .catch(function (error) {
      dispatch(hideLoading());
      handleApiError(error);
    });
};

export const getKYCContractStatusDDL = () => async (dispatch) => {
  dispatch(showLoading());
  return await axios
    .get(`api/LenderKYC/GetContractStatusDDL`)
    .then(({ data }) => {
      dispatch(hideLoading());
      return data.response;
    })
    .catch(function (error) {
      dispatch(hideLoading());
      handleApiError(error);
      return null;
    });
};

export const getAppGlobalSettingByVariableName = (variableName) => async (dispatch) => {
    dispatch(showLoading());

    try {
        const { data } = await axios.get(
            `api/AppGlobalSetting/GetAppGlobalSettingByVariableName/${variableName}`
        );

        return data.response;
    } catch (error) {
        handleApiError(error);
        return null;
    } finally {
        dispatch(hideLoading());
    }
};

export const getKycSingleRecord = (id, isV2 = false) => async (dispatch) => {
  dispatch(showLoading());
  return await axios
    .get(
      `api/LenderKYC/${isV2 ? "GetKycSingleRecordCbV2" : "GetKycSingleRecord"}/${id}`
    )
    .then(({ data }) => {
      dispatch(hideLoading());
      return data.response;
    })
    .catch(function (error) {
      dispatch(hideLoading());
      handleApiError(error);
      return null;
    });
};

export const updateUserKycProcess = (req) => async (dispatch) => {
  dispatch(showLoading());
  return await axios
    .post(`api/LenderKYC/FormListUpdateUserKycProcess`, req)
    .then(({ data }) => {
      dispatch(hideLoading());
      return data;
    })
    .catch(function (error) {
      dispatch(hideLoading());
      handleApiError(error);
      return null;
    });
};

export const changeContractStatusForWeb = (vizcode) => async (
  dispatch
) => {
  dispatch(showLoading());
  return await axios
    .post(
      `api/LenderKYC/CreditBook/ChangeContractStatusForWeb?vizSHopCode=${vizcode}`
    )
    .then(({ data }) => {
      dispatch(hideLoading());
      return data;
    })
    .catch(function (error) {
      dispatch(hideLoading());
      handleApiError(error);
      return null;
    });
};

export const getComplianceDocuments = () => async (dispatch) => {
  dispatch(showLoading());
  return await axios
    .get(`api/Lender/GetComplianceDocuments`)
    .then(({ data }) => {
      dispatch(hideLoading());
      return data.response || data;
    })
    .catch(function (error) {
      dispatch(hideLoading());
      handleApiError(error);
      return null;
    });
};

export const submitCreditBookV2KYC = (payload) => async (dispatch) => {
  dispatch(showLoading());
  return await axios
    .post(`api/LenderKYC/CreditBook/V2/SubmitUserKYC`, payload)
    .then(({ data }) => {
      dispatch(hideLoading());
      return data;
    })
    .catch(function (error) {
      dispatch(hideLoading());
      handleApiError(error);
      return null;
    });
};

export const saveCustomerInfoToUpdateByKycId = (kycId, payload) => async (dispatch) => {
  dispatch(showLoading());

  return await axios
    .post(`api/LenderKYC/SaveCustomerInfoToUpdateByKycId/${kycId}`, payload)
    .then(({ data }) => {
      dispatch(hideLoading());
      return data;
    })
    .catch((error) => {
      dispatch(hideLoading());
      handleApiError(error);
      return null;
    });
};
